import { cn } from "@/lib/utils";

/**
 * v23.111b — Logo NexTrack (rebranding de "NexTags Track" → "NexTrack").
 *
 * SVG mark da NexTags (mantido — é o ícone-mãe da empresa) + wordmark
 * "Nex" branco + "Track" roxo. Mantém o split visual antigo só com a
 * marca consolidada num nome só.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2.5 font-semibold text-fg", className)}>
      <div className="h-10 w-10 rounded-lg flex items-center justify-center text-white logo-mark">
        <NextagsLogoSvg className="h-7 w-7" />
      </div>
      <span className="text-base font-semibold tracking-tight">
        Nex<span className="text-[#A855F7]">Track</span>
      </span>
    </div>
  );
}

/**
 * SVG do logo NexTags. Cor herdada via `currentColor` — pode ser pintada
 * com `text-{color}` ou via `color` CSS prop no parent.
 */
export function NextagsLogoSvg({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 1040 1040"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="NexTags"
      {...props}
    >
      <path
        d="M452.371 586.146L682.948 728.578V628.2L605.159 586.146L682.948 551.537V451.583L452.371 586.146Z"
        fill="currentColor"
      />
      <path
        d="M603.354 476.374L372.777 618.806V518.428L450.566 476.374L372.777 441.765V341.811L603.354 476.374Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M666.71 213.467C663.622 218.186 661.826 223.828 661.826 229.888V261.64C654.378 259.059 646.451 257.687 638.329 257.688H638.324L401.671 257.695L401.666 257.695C376.014 257.7 352.325 271.376 339.493 293.587L339.488 293.596L221.173 498.561L221.168 498.57C208.343 520.775 208.345 548.14 221.168 570.351L339.506 775.318C352.33 797.529 376.027 811.213 401.67 811.209H401.675L555.905 811.205L555.896 811.189L638.314 811.177C663.969 811.174 687.662 797.496 700.494 775.28L700.497 775.276L818.829 570.332L818.832 570.327C831.656 548.122 831.655 520.757 818.831 498.546L717.54 323.105H772.547L860.086 474.727C881.417 511.673 881.425 557.2 860.084 594.152L741.749 799.1C728.99 821.192 709.77 838.211 687.257 848.326C672.131 855.123 655.518 858.804 638.379 858.815H638.335H638.32L638.335 858.84H638.32H638.276L583.355 858.842L401.677 858.847C359.005 858.853 319.581 836.083 298.251 799.137L179.913 594.17C158.582 557.224 158.574 511.697 179.915 474.746L298.236 269.772C319.577 232.82 358.993 210.063 401.665 210.057L638.323 210.05C648.01 210.049 657.53 211.222 666.71 213.467Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M633.384 181.153C616.799 181.153 603.354 194.598 603.354 211.182V311.781C603.354 328.366 616.799 341.811 633.384 341.811H824.429C841.014 341.811 854.458 328.366 854.458 311.781V211.182C854.458 194.598 841.014 181.153 824.429 181.153H633.384ZM665.923 304.237H687.365L695.533 285.348H738.288L746.328 304.237H768.28L730.63 218.726H703.318L665.923 304.237ZM702.935 268.118L710.976 249.485L716.208 236.211H717.612L722.845 249.485L730.886 268.118H702.935ZM772.746 304.237H791.891V218.726H772.746V304.237Z"
        fill="currentColor"
      />
    </svg>
  );
}
